import { Command, HttpVerbType, API_PREFIX, API_VERSION } from "../Command";
import { GetAvailableLanguagesResponse } from "./GetAvailableLanguagesResponse";

const ENDPOINT = "/misc/languages";

export class GetAvailableLanguagesCommand extends Command {
    endPoint: string = API_PREFIX + API_VERSION + ENDPOINT;
    httpVerb: HttpVerbType = "get";

    public async execute(): Promise<GetAvailableLanguagesResponse> {
        let res = await this.executeCommand();
        return new GetAvailableLanguagesResponse(res);
    }
}
